var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20Z",
    fill: "#009393"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2392 10H28.0789C28.4569 10 28.806 10.2022 28.9945 10.5302L33.6092 18.561C33.8485 18.9774 33.7775 19.5031 33.4361 19.8408L20.7338 32.408C20.3224 32.8151 19.6605 32.8151 19.249 32.408L6.5639 19.8578C6.21462 19.5122 6.14921 18.9713 6.40606 18.5522L11.3389 10.5044C11.531 10.191 11.8719 10 12.2392 10ZM26.0337 13.5855V15.8388H21.5216V17.4011C24.6906 17.568 27.0682 18.2537 27.0858 19.0756L27.0857 20.789C27.0681 21.6109 24.6906 22.2966 21.5216 22.4635V26.2976H18.5255V22.4635C15.3565 22.2966 12.9789 21.6109 12.9613 20.789L12.9614 19.0756C12.979 18.2537 15.3565 17.568 18.5255 17.4011V15.8388H14.0134V13.5855H26.0337ZM20.0236 21.2864C23.4054 21.2864 26.2321 20.7066 26.9239 19.9323C26.3373 19.2757 24.2154 18.7589 21.5216 18.617V20.2527C21.0388 20.2782 20.5376 20.2916 20.0236 20.2916C19.5095 20.2916 19.0083 20.2782 18.5255 20.2527V18.617C15.8317 18.7589 13.7098 19.2757 13.1232 19.9323C13.815 20.7066 16.6417 21.2864 20.0236 21.2864Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.0617e250ede27b49b0e5f9f5b1a5619a.svg";
export { ForwardRef as ReactComponent };